const getApiUrl = () => {
  if (process.env.NEXT_PUBLIC_VERCEL_ENV === `preview`) {
    return "https://api-internal.tokenterminal.dev"
  }
  if (process.env.NEXT_PUBLIC_USE_LOCAL_SERVER === `true`) {
    return "http://localhost:3001"
  }
  return "https://api-internal.tokenterminal.com"
}

export const API_URL = getApiUrl()
